export default "__VITE_ASSET__BetLHBg5__"